import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { PageEvent } from "@angular/material/paginator";
import { kits, kitsDTO } from "../models/kits";
import { take } from "rxjs";
import { Page } from "../../shared/models/page.model";
import { ItemDTO } from "../../orders/models/order";

@Injectable({
  providedIn: 'root'
})
export class KitService {
  constructor(private http: HttpClient) { }

  kitsUrl: string = `${environment.apiUrl}/api/kits`;
  itemsUrl: string = `${environment.apiUrl}/api/items`;

  createKit(formData: FormData){
    return this.http.post<kits>(`${this.kitsUrl}/create`, formData).pipe(take(1))
  }

  updateKit(formData: FormData, id: number){
    return this.http.put<kits>(`${this.kitsUrl}/${id}`, formData).pipe(take(1))
  }

  deleteKit(kit: kits, id: number){
    return this.http.put<kitsDTO>(`${this.kitsUrl}/deactivate/${id}`, kit).pipe(take(1))
  }

  listKitsPaginated(pager: PageEvent){
    let params = new HttpParams()
      .append('page', pager.pageIndex)
      .append('size', pager.pageSize)

      return this.http.get<Page<kitsDTO>>(`${this.kitsUrl}/list`, {params}).pipe(take(1))
  }

  listKitsPaginatedandFiltered(pager: PageEvent, filter?: string){
    let params = new HttpParams()
        .append('page', pager.pageIndex)
        .append('size', pager.pageSize)
        .append('filter', filter ? filter : '');

        return this.http.get<Page<kitsDTO>>(this.kitsUrl, {params}).pipe(take(1));
  }

  getKitById(id: number){
    return this.http.get<kitsDTO>(`${this.kitsUrl}/details-kit/${id}`).pipe(take(1))
  }

  getKitImage(idKit?: number){
    return this.http.get(`${this.kitsUrl}/images?idKit=${idKit}`,{responseType:'blob'}).pipe(take(1))
  }

  getKitImageUrl(filename: string): string {
    return `${this.kitsUrl}/images?filename=${filename}`;
  } 

  getListItems(filter: string){
    let params = new HttpParams().append('filter', filter ? filter : '');
    return this.http.get<ItemDTO[]>(`${this.itemsUrl}/list-all-items`, {params}).pipe(take(1));
  }

  deleteItem(formData: FormData, id: number){
    return this.http.put<String>(`${this.kitsUrl}/deactivate-item/${id}`, formData).pipe(take(1))
  }
}
